import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ChatSurface from 'components/Chat/ChatSurface';
import useAiAssistantAccess from 'utils/useAiAssistantAccess';

const Chat = () => {
	const navigate = useNavigate();
	const hasAiAssistantAccess = useAiAssistantAccess();

	useEffect(() => {
		document.title = 'CAP Assistant';
	}, []);

	// The route is reachable by typing the URL, not just from the sidebar, so
	// the allow list is enforced here too rather than only by hiding the way in.
	useEffect(() => {
		if (!hasAiAssistantAccess) {
			navigate('/dashboard', { replace: true });
		}
	}, [hasAiAssistantAccess, navigate]);

	return hasAiAssistantAccess ? <ChatSurface /> : null;
};

export default Chat;
